<template>
    <div id="anonimoFinalizaYPaga">
        <h1>Estás apunto de finalizar tu compra por {{ amount | currency }} </h1>
        <p>
            Al finalizar serás redirigido a la sección de pago
            donde podrás pagar con varios métodos de pago.
        </p>
        <p class="importante">
            Ten en cuenta que tu pedido durará activo solo 24horas, después de éste periodo, será cancelado
            automáticamente.
        </p>
    </div>
</template>

<script>
export default {
    name: 'anonimoFinalizaYPaga',
    props: {
        amount: {
            type: [String, Number],
            default: '0'
        }
    }
}
</script>

<style lang="less">
#anonimoFinalizaYPaga {
    text-align: center;
    padding: 1em;
    background-color: var(--dimmed-light);
    margin: 1em;
    border-radius: 1em;

    .importante {
        font-weight: bold;
    }

    h1 {
        font-size: 1.8em;
        color: var(--primary);
    }

}
</style>